import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface CreditsPurchaseSettingValue {
  enabled: boolean;
}

export function useCreditsPurchaseEnabled() {
  const { data, isLoading } = useQuery({
    queryKey: ["app-settings", "credits_purchase_enabled"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("app_settings")
        .select("value")
        .eq("key", "credits_purchase_enabled")
        .single();

      if (error) {
        console.error("Error fetching credits purchase setting:", error);
        return true; // Default to enabled if there's an error
      }

      const value = data?.value as unknown as CreditsPurchaseSettingValue;
      return value?.enabled ?? true;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });

  return {
    isCreditsPurchaseEnabled: data ?? true,
    isLoading,
  };
}
